import { IsString } from "class-validator";

export class AdminUpdateAccountPayload {
    @IsString()
    companyName: string;
}